import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { setAuth } from 'src/app/state/auth.actions';
import { selectAuth } from 'src/app/state/auth.selectors';
import { resetStore } from 'src/app/state/reset-store.actions';
import { ShoppingCartService } from './shopping-cart.service';
import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  auth: AuthModel;

  constructor(
    private router: Router,
    private store: Store,
    private shoppingCartService: ShoppingCartService,
    private accountService: AccountService
  ) {
    this.store.pipe(select(selectAuth))
      .subscribe(x => {
        this.auth = x;
        this.shoppingCartService.getShoppingCart();
      });
  }

  getToken() {
    return this.hasAuth() ? this.auth.access_token : null;
  }

  logout() {
    if (this.hasAuth()) {
      this.accountService.InvalidateAccessToken().subscribe({
        next: (response) => {
          
        },
        error: (error) => {
         
        },
        complete: () => {
          this.cleanupAndRedirect();
        }
      });
    }

    this.cleanupAndRedirect();
  }

  cleanupAndRedirect() {
    this.store.dispatch(resetStore());
    sessionStorage.clear();
    this.redirectToLoginPage();
  }

  public setAuthentication(newAuth: AuthModel, email: string) {
    newAuth.email = email;
    this.store.dispatch(setAuth({ auth: newAuth }));
  }

  public getEmail(): string {
    return this.hasAuth() ? this.auth.email : null;
  }

  private redirectToLoginPage() {
    this.router.navigate(['/login']);
  }

  private hasAuth(): boolean {
    return this.auth && this.auth != null;
  }
}
